'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.user = user;

var _user = require('../actions/user');

/**
 *
 */
var initialState = {};

/**
 *
 */
function user() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var _ref = arguments[1];
	var type = _ref.type;
	var payload = _ref.payload;

	switch (type) {
		case _user.SET:
			return payload.user;

		default:
			return state;
	}
}